'use client';
export default function Home() {
  return (
    <main className="flex justify-center items-center h-full w-full px-4">
      <div className="bg-gray-200 w-full max-w-md p-10 text-center">
        <p className="text-sm text-[#090039] mb-4">
          Welcome to Zync eSign Portal<br />
        </p>
      </div>
    </main>
  );
}
